/** Dedupe (case-insensitive), trim, sort for stable UI. */
export function mergeDatabaseNameLists(...lists: (readonly string[] | undefined)[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const list of lists) {
    if (!list?.length) continue;
    for (const item of list) {
      const t = String(item).trim();
      if (t === '') continue;
      const k = t.toLowerCase();
      if (seen.has(k)) continue;
      seen.add(k);
      out.push(t);
    }
  }
  return out.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}
